import produce from 'immer';
import {
  ENCARGOS_SET_WORKSPACE,
  ENCARGOS_SET_LOADING,
  ENCARGOS_ADD_ARTICLE_FROM_ENCARGO,
  ENCARGOS_REMOVE_ARTICLE_FROM_ENCARGO,
  ENCARGOS_MARCAR_ARTICULOS,
  ENCARGOS_DEVOLVER_ARTICULOS_REQUEST,
  ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS, ENCARGOS_SELECCIONAR_LINEA,
} from '../actions/constants/encargos.constants';

const initialState = {
  promocionId: null,
  promocion: null,
  nombrePack: null,
  encargos: [],
  tituloEspacioDeTrabajo: null,
};

export default function encargosWorkspace(state = initialState, { type, payload }) {
  switch (type) {
    case ENCARGOS_SET_WORKSPACE: {
      const {
        encargos, promocion, resumenPrecios, tituloEspacioDeTrabajo,
      } = payload;
      return {
        ...state, encargos, promocion, loading: false, resumenPrecios, tituloEspacioDeTrabajo,
      };
    }
    case ENCARGOS_SET_LOADING: {
      const { loading } = payload;
      return {
        ...state, loading,
      };
    }
    case ENCARGOS_ADD_ARTICLE_FROM_ENCARGO: {
      const { encargoId, articulo, append } = payload;
      const { encargos } = state;
      return {
        ...state,
        encargos: [...encargos].map((encargo) => {
          const { id, articulos } = encargo;
          if (id === encargoId) {
            const linea = articulos.length;
            const newArticulosEncargo = (append === false) ? [{ ...articulo, linea }] : [...articulos, { ...articulo, linea }];
            return { ...encargo, articulos: newArticulosEncargo };
          }
          return encargo;
        }),
      };
    }
    case ENCARGOS_REMOVE_ARTICLE_FROM_ENCARGO: {
      const { encargoId, articulo: { id: articuloId } } = payload;
      return produce(state, (draft) => {
        const encargoIndex = draft.encargos.findIndex(encargo => encargo.id === encargoId);
        const articulosFiltered = draft.encargos[encargoIndex].articulos.filter(articulo => articulo.id !== articuloId);
        draft.encargos[encargoIndex].articulos = articulosFiltered;
        return draft;
      });
    }
    case ENCARGOS_MARCAR_ARTICULOS: {
      const {
        encargo: { id: encargoId }, articulos, agrupacionId, value,
      } = payload;
      return produce(state, (draft) => {
        const encargoIndex = draft.encargos.findIndex(encargo => encargo.id === encargoId);
        const agrupacionIndex = draft.encargos[encargoIndex].articulosAgrupados.findIndex(agrupacion => agrupacion.computedId === agrupacionId);

        const checkedDetalles = draft.encargos[encargoIndex].articulosAgrupados[agrupacionIndex].detalles.map((detalle) => {
          let { checked } = detalle;
          if (detalle.devuelto !== true) {
            if (articulos.findIndex(articulo => articulo.linea === detalle.linea) !== -1) {
              if (value != undefined) {
                checked = value;
              } else {
                checked = (checked == undefined) ? true : !checked;
              }
            }
          }
          return {
            ...detalle,
            checked,
          };
        });
        draft.encargos[encargoIndex].articulosAgrupados[agrupacionIndex].detalles = checkedDetalles;
        return draft;
      });
    }
    case ENCARGOS_DEVOLVER_ARTICULOS_SUCCESS: {
      return {
        ...state,
      };
    }
    case ENCARGOS_SELECCIONAR_LINEA: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
}
